module.exports = __webpack_public_path__ + "45827636cb4ab0a918b6294a4d0d2548.jpg";